import { StatusComponent } from '../all-screenings/component/StatusComponent';
import clinicDispatcher from '../clinic/actions';
import TableCellFilted from '../common/componentUI/TableCellFilted';
import { ROLE_TYPE } from '../role-management/constants';
import adminDispatcher from './action';
import GroupToolbar from './component/GroupToolbar';
import ModalAddOrEditUser from './component/ModalAddOrEditUser';
import {
  COLUMN_USERS_MANAGEMENT,
  ROLE_STATUS,
  USERS_STATUS,
  USERS_STATUS_COLORS,
  TYPE_MODAL,
  DEFAULT_FIELD,
  ROLE_FIELD,
  SINGLE_IMAGE,
  LIST_IMAGES,
} from './constants';
import { CloseCircle, CreateNewIcon, EditIcon } from '@/assets/svg';
import { uploadImage } from '@/firebase';
import { filterObjectByKeys, handleSelectAll } from '@/helpers';
import CustomMenu from '@/new-components/CustomMenu';
import CustomMenuActions from '@/new-components/CustomMenuActions';
import ModalConfirmation from '@/new-components/CustomModal/ModalConfirmation';
import CustomPaperContainer from '@/new-components/CustomPaperContainer';
import CustomHeader from '@/new-components/CustomPaperContainer/CustomHeader';
import CustomTable from '@/new-components/CustomTable';
import CustomTooltip from '@/new-components/CustomTooltip';
import {
  Button,
  Drawer,
  IconButton,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { MoreVertRounded } from '@material-ui/icons';
import { debounce, find, isEmpty, get } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

const AdminManagement = () => {
  const {
    paging,
    list: data,
    loading,
    listAdminRole,
  } = useSelector((state) => state.admin);
  const { list: listClinic } = useSelector((state) => state.clinic);
  const { userInfo, roleType } = useSelector((state) => state.auth);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});
  const [typeModal, setTypeModal] = useState(null);

  const [sortOption, setSortOption] = useState({});
  const [searchKey, setSearchKey] = useState('');

  const [locationIds, setLocationIds] = useState([]);

  const [filterOption, setFilterOption] = useState({ roleType: [] });

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [clinicFilter, setClinicFilter] = useState([]);
  const isClinicManager = roleType === 'ClinicManager';

  const roleOptions = useMemo(() => {
    return listAdminRole.map((item) => ({
      key: item.roleType,
      value: item.label,
    }));
  }, [listAdminRole]);

  const onFilterOptionChange = (key) => (e, newValue) => {
    let value = e.target.value;

    switch (key) {
      case 'roleType':
        value = handleSelectAll(
          value,
          roleOptions.map((item) => item.key),
          filterOption.roleType
        );
        break;

      default:
        break;
    }

    setFilterOption({
      ...filterOption,
      [key]: value,
    });
  };

  const onResetFilterOps = () => {
    setFilterOption({});
  };
  const onShowModal = (type) => {
    setShowModal(true);
    setTypeModal(type);
  };

  const onCloseModal = () => {
    setShowModal(false);
    setTypeModal(null);
  };
  const handleDeleteAdmin = () => {
    if (isEmpty(selectedItem)) return;
    adminDispatcher.deleteData(selectedItem.id, searchKey, filterOption);
    setShowCancelModal(false);
  };

  const fetchData = async (
    search = searchKey,
    pagingData = paging,
    filterOptionData = filterOption
  ) => {
    adminDispatcher.getData(search, pagingData, filterOptionData);
  };

  const debounceLoadData = useCallback(
    debounce((searchKey, paging, filterOption) => {
      fetchData(
        searchKey,
        {
          pageIndex: 0,
          pageSize: paging.pageSize,
        },
        filterOption
      );
    }, 500),
    []
  );

  const onSubmitSuccess = () => {
    adminDispatcher.getData(searchKey, paging, filterOption);
    setShowModal(false);
    setTypeModal(null);
  };

  const onSubmitAdmin = async (formValue) => {
    adminDispatcher.setState('loading', true);
    //filter field by role
    const requiredField = DEFAULT_FIELD.concat(
      ROLE_FIELD[get(formValue, 'roleType.roleType', formValue.roleType)]
    );
    //filter object field
    let values = filterObjectByKeys(formValue, requiredField);
    const formProps = Object.getOwnPropertyNames(values);

    //async upload images
    const singleImgProps = formProps.filter((prop) =>
      SINGLE_IMAGE.includes(prop)
    );
    if (!!singleImgProps.length) {
      const listSingleImg = await Promise.all(
        singleImgProps.map(async (prop) => {
          if (values[prop]?.constructor === File) {
            const urlPath = await uploadImage(values[prop]);
            return { url: urlPath, key: prop };
          } else return { url: values[prop], key: prop };
        })
      );
      listSingleImg.forEach((img) => {
        values[img.key] = img.url;
      });
    }
    //
    if (formProps.includes(LIST_IMAGES) && !isEmpty(values[LIST_IMAGES])) {
      const listImgs = await Promise.all(
        values[LIST_IMAGES].map(async (file) => {
          if (file?.constructor === File) {
            const urlPath = await uploadImage(file);
            return urlPath;
          } else return file;
        })
      );
      values[LIST_IMAGES] = listImgs;
    }
    //format roleType
    values.roleType = get(formValue, 'roleType.roleType', formValue.roleType);
    if (typeModal === TYPE_MODAL.Create) {
      adminDispatcher.createUser(values, onSubmitSuccess);
    } else if (typeModal === TYPE_MODAL.Edit) {
      adminDispatcher.updateUser(
        { id: selectedItem.id, data: values },
        onSubmitSuccess
      );
    }
  };

  useEffect(() => {
    debounceLoadData(searchKey, paging, filterOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey, filterOption]);

  useEffect(() => {
    adminDispatcher.getAdminRole();
    clinicDispatcher.getAllClinic();
  }, []);

  useEffect(() => {
    if (userInfo && isClinicManager) {
      const newListClinic = listClinic.map((clinic) => {
        const foundItem = userInfo?.lstClinic?.find(
          (item) => item.id === clinic.id
        );

        if (foundItem) {
          return { ...clinic, isDisabled: false };
        } else return { ...clinic, isDisabled: true };
      });
      setClinicFilter(newListClinic);
    } else {
      setClinicFilter(listClinic);
    }
  }, [listClinic, userInfo, isClinicManager]);

  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {COLUMN_USERS_MANAGEMENT.map((item) =>
          item.sortBy ? (
            <TableCellFilted
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
              sortBy="Date"
              sortOption={sortOption}
              onSortChange={() => {
                let newSortOption = {
                  sortBy: 'BookedApptDate',
                  orderBy: sortOption.orderBy !== 'Asc' ? 'Asc' : 'Desc',
                };
                setSortOption(newSortOption);
              }}
              style={{
                minWidth: item.minWidth || 'unset',
                width: item.width || 'unset',
              }}
              isHidden={false}
            />
          ) : (
            <TableCellFilted
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
              style={{
                minWidth: item.minWidth || 'unset',
                width: item.width || 'unset',
              }}
              isHidden={false}
            />
          )
        )}
      </TableRow>
    </TableHead>
  );

  const renderTableBody = (row) => {
    return (
      <>
        <TableCell>
          <CustomTooltip
            content={
              isEmpty(row.firstName)
                ? row.fullName
                : row.firstName + ' ' + row.lastName
            }
          />
        </TableCell>
        <TableCell>
          <CustomTooltip content={row.email || '—'} />
        </TableCell>
        <TableCell>
          {find(ROLE_TYPE, ['roleType', row.roleType])?.label}
        </TableCell>
        <TableCell>
          <StatusComponent
            filterList={USERS_STATUS}
            filterListColor={USERS_STATUS_COLORS}
            status={
              row[
                ROLE_STATUS.Approved.includes(row.roleType)
                  ? 'approveStatus'
                  : 'activeStatus'
              ]
            }
          />
        </TableCell>
        <TableCell>
          <IconButton
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
              setSelectedItem(row);
            }}
          >
            <MoreVertRounded />
          </IconButton>
        </TableCell>
      </>
    );
  };
  const listActions = [
    {
      key: 'edit',
      icon: EditIcon,
      label: 'Edit user',
      styles: { width: 20, height: 20 },
      onClick: () => {
        setAnchorEl(null);
        onShowModal(TYPE_MODAL.Edit);
      },
    },
    {
      key: 'cancel',
      icon: CloseCircle,
      label: 'Delete user',
      color: '#DB3D49',
      styles: { width: 18, height: 18 },
      onClick: () => {
        setAnchorEl(null);
        setShowCancelModal(true);
      },
    },
  ];

  return (
    <>
      <CustomMenu
        id="simple-menu"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <CustomMenuActions listActions={listActions} />
      </CustomMenu>
      <CustomPaperContainer
        header={
          <CustomHeader
            searchPlaceholder="Search by name or ID number..."
            title="Users"
            setSearchKey={setSearchKey}
            searchKey={searchKey}
            filterOption={filterOption}
            setFilterOption={setFilterOption}
            sortOption={sortOption}
            fetchData={fetchData}
            renderToolbar={() => (
              <GroupToolbar
                filterOption={filterOption}
                setFilterOption={setFilterOption}
                onFilterOptionChange={onFilterOptionChange}
                onResetFilterOps={onResetFilterOps}
                locationIds={locationIds}
                setLocationIds={setLocationIds}
                listAdminRole={roleOptions}
              />
            )}
            renderButton={() => (
              <>
                <Button
                  color="primary"
                  variant="contained"
                  startIcon={<CreateNewIcon />}
                  onClick={() => {
                    setSelectedItem(null);
                    onShowModal(TYPE_MODAL.Create);
                  }}
                >
                  Create new
                </Button>
              </>
            )}
          />
        }
      >
        <CustomTable
          data={data}
          paging={paging}
          header={TableHeader}
          renderRow={(row, i) => renderTableBody(row)}
          noDataHelperText="No users"
          noDataHelperSubText="Please create a new user."
          totalCols={COLUMN_USERS_MANAGEMENT.length}
          fetchData={fetchData}
        />
      </CustomPaperContainer>

      {showModal && (
        <ModalAddOrEditUser
          open={showModal}
          onClose={onCloseModal}
          typeModal={typeModal}
          onSubmit={onSubmitAdmin}
          selectedItem={selectedItem}
          listAdminRole={listAdminRole}
          listClinic={clinicFilter}
          isClinicManager={isClinicManager}
          loading={loading}
        />
      )}
      {showCancelModal && (
        <ModalConfirmation
          open={showCancelModal}
          onClose={() => setShowCancelModal(false)}
          onClick={handleDeleteAdmin}
          mainContent={'Delete user'}
          subContent={'Are you sure you want to delete this user?'}
          cancelLabel="Cancel"
          confirmLabel="Delete"
          confirmColor="red"
        />
      )}
    </>
  );
};
export default AdminManagement;
